import { BasePresenter } from "core/presenter";
import { CategoryRepository, ProductRepository } from "core/repository";
import { Category } from "core/entity";
import { fn } from "util";
import uuid from "uuid";

export default class CategoryListPresenter extends BasePresenter {
  initialState() {
    return {
      loading: true,
      categories: [],
      form: {
        visible: false,
        category: new Category(),
        mode: "create"
      }
    };
  }

  async onStart() {
    this.load();
  }

  async onChangeTree(data) {
    this.viewModel.treeData = data;
  }

  async load() {
    this.viewModel.loading = true;
    this.renewCancelToken();

    const result = await CategoryRepository.getAll({
      order: [{ field: "name", direction: "ASC" }],
      filters: await this.getFilters()
    });

    if (result.success) {
      const treeData = fn.filteredTreeDataFromFlatData(
        result.data,
        "uuid",
        "category_uuid",
        category => !category.deleted
      );
      this.viewModel.categories = fn.flatDataFromTreeData(treeData);
    } else if (!result.userCancelled) {
      this.sendNotification({
        type: "error",
        title: "Oops",
        content:
          "Não foi possível carregar as categorias. Tente novamente mais tarde."
      });
    }

    this.viewModel.loading = false;
  }

  async getFilters() {
    const currentUser = await this.mRuntime.get("currentUser");

    return [
      { connector: "AND", field: "deleted", operation: "EQ", value: "false" },
      {
        connector: "AND",
        field: "company_uuid",
        operation: "EQ",
        value: currentUser.company_uuid
      }
    ];
  }

  onMoveCategory(target, destination) {
    let destinationName, destinationUuid;

    if (destination) {
      destinationName = `a categoria ${destination.name}`;
      destinationUuid = destination.uuid;
    } else {
      destinationName = "fora de todas as outras categorias";
      destinationUuid = null;
    }

    this.sendNotification({
      type: "confirmation",
      title: "Você tem certeza?",
      content: `Ao confirmar, a categoria ${target.name} será movida para ${destinationName}`,
      actions: [
        { label: "Não, quero voltar", type: "accent" },
        {
          label: "Sim, quero mover",
          type: "primary",
          callback: () => this.doMove(target.uuid, destinationUuid)
        }
      ]
    });
  }

  async doMove(targetUuid, destinationUuid) {
    this.viewModel.loading = true;

    const result = await CategoryRepository.update(targetUuid, {
      category_uuid: destinationUuid
    });

    if (result.success) {
      this.sendNotification({
        type: "success",
        content: "Categoria movida com sucesso!"
      });

      this.load();
    } else {
      this.sendNotification({
        type: "error",
        title: "Oops",
        content:
          "Não foi possível mover esta categoria. Tente novamente mais tarde ou entre em contato com o suporte."
      });
    }

    this.viewModel.loading = false;
  }

  createCategory(category_uuid) {
    this.viewModel.form.category.uuid = uuid();
    this.viewModel.form.category.name = "";
    this.viewModel.form.category.category_uuid = category_uuid;
    this.viewModel.form.visible = true;
    this.viewModel.form.mode = "create";
  }

  editCategory(category) {
    this.viewModel.form.category.uuid = category.uuid;
    this.viewModel.form.category.name = category.name;
    this.viewModel.form.category.category_uuid = category.category_uuid;
    this.viewModel.form.visible = true;
    this.viewModel.form.mode = "edit";
  }

  onCloseForm(entityCreated) {
    this.viewModel.form.visible = false;

    if (entityCreated) {
      this.load();
    }
  }

  async deleteCategory(category) {
    this.viewModel.loading = true;

    const filters = [
      { field: "category_uuid", operation: "EQ", value: category.uuid },
      { field: "deleted", operation: "EQ", value: false }
    ];
    const childrenCategoriesPromise = CategoryRepository.findFirst({ filters });
    const childrenSellablesPromise = ProductRepository.findFirst({ filters });

    const [
      childrenCategoriesResult,
      childrenSellablesResult
    ] = await Promise.all([
      childrenCategoriesPromise,
      childrenSellablesPromise
    ]);

    const hasChildren = childrenCategoriesResult || childrenSellablesResult;

    if (hasChildren) {
      this.sendNotification({
        type: "confirmation",
        title: "Desabilitar categoria",
        content: `Deseja desabilitar os produtos e subcategorias da categoria ${category.name} ou movê-los para a categoria principal?`,
        actions: [
          {
            label: "Cancelar",
            type: "accent",
            callback: () => (this.viewModel.loading = false)
          },
          {
            label: "Mover",
            type: "primary",
            callback: () => this.doDeleteCategory(category, "move_to_root")
          },
          {
            label: "Desabilitar",
            type: "primary",
            callback: () => this.doDeleteCategory(category, "delete")
          }
        ]
      });
    } else {
      this.doDeleteCategory(category, "delete");
    }
  }

  async doDeleteCategory(category, action) {
    const result = await CategoryRepository.disable(category.uuid, action);

    if (result.success) {
      this.sendNotification({
        type: "success",
        content: "Categoria deletada com sucesso!"
      });
      this.load();
    } else {
      this.sendNotification({
        type: "error",
        title: "Oops",
        content:
          "Não foi possível deletar essa categoria. Contate o suporte ou tente novamente em alguns minutos."
      });
    }

    this.viewModel.loading = false;
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/category/list/presenter.js